import { api_endpoint } from "../env";

export { api_endpoint };
